import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const Header = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section, header");
      const scrollPosition = window.scrollY + window.innerHeight / 3;

      let currentSection = "home";

      sections.forEach((section) => {
        if (section.id) {
          const sectionTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            currentSection = section.id;
          }
        }
      });

      setActiveLink(currentSection);
    };

    // Set initial active link
    handleScroll();

    // Add scroll listener
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [data]);




  if (!data) return null;


  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const { firstName, description, social } = data;

  const networks = social.map((network) => (
    <li key={network.name}>
      <a href={network.url} target="_blank" rel="noopener noreferrer">
        <i className={network.className}></i>
      </a>
    </li>
  ));

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <header id="home" style={{ height: "100vh" }}>
      <nav id="nav-wrap">
        <div className="mobile-menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? "fa fa-times" : "fa fa-bars"}></i>
        </div>

        <ul id="nav" className={`nav ${isOpen ? "open" : ""}`}>
          <li className={activeLink === "home" ? "current" : ""}>
            <a className="smoothscroll" href="#home" onClick={closeMenu}>
              Home
            </a>
          </li>
          <li className={activeLink === "about" ? "current" : ""}>
            <a className="smoothscroll" href="#about" onClick={closeMenu}>
              About
            </a>
          </li>
          <li className={activeLink === "resume" ? "current" : ""}>
            <a className="smoothscroll" href="#resume" onClick={closeMenu}>
              Resume
            </a>
          </li>
          <li className={activeLink === "portfolio" ? "current" : ""}>
            <a className="smoothscroll" href="#portfolio" onClick={closeMenu}>
              Works
            </a>
          </li>
          <li className={activeLink === "contact" ? "current" : ""}>
            <a className="smoothscroll" href="#contact" onClick={closeMenu}>
              Contact
            </a>
          </li>
        </ul>
      </nav>


      <div className="row banner">
        <div className="banner-text">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.h2 variants={itemVariants} className="responsive-headline">
              Hello, I'm {firstName}!
            </motion.h2>
            <motion.h3 variants={itemVariants}>
              {description}.
            </motion.h3>
            <motion.div variants={itemVariants}>
              <hr />
            </motion.div>
            <motion.ul variants={itemVariants} className="social">
              {networks}
            </motion.ul>
          </motion.div>
        </div>
      </div>

      <p className="scrolldown">
        <a className="smoothscroll" href="#about">
          <motion.span
            style={{ display: "inline-block" }}
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
          >
            <i className="icon-down-circle"></i>
          </motion.span>
        </a>
      </p>
    </header>
  );
};

export default Header;
